import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'absolute',
        boxSizing: 'border-box',
        overflow: 'hidden',

        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0,
            border: '1.5px solid',
            borderRadius: '2px',
            borderColor: theme.palette.text.secondary,
            pointerEvents: 'none',
            zIndex: 5,
            transitionProperty: 'opacity',
            transitionDuration: '0.2s'
        }
    },
    active: {
        '&::after': {
            opacity: 1
        }
    }
}))

export default useStyles